export default function (...args)
{
	return {
		regex: /^(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})$/,
		filter: /[\s]/g,
		store_mask: '$1$2$3$4$5$6$7$8$9$10$11',
		display_mask: '$1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11',
	};
}

